import { defineStore } from 'pinia'

export const useAreaRouteState = defineStore('areaRouteModal', {
  state: () => ({
    isShow: false
  }),
  actions: {
    setIsShow (value) {
      // replace entire modalForm with new object
      this.isShow = value
    }

  }
})
